import { useEffect, useState } from 'react';
import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  isSameMonth,
  isSameDay,
  isBefore,
  isAfter,
  startOfDay
} from 'date-fns';
import { es } from 'date-fns/locale';
import api from '../api/axios';

export default function Calendario({
  fechaSeleccionada,
  onSeleccionarFecha,
  servicioId,
  diasMaximos = 28,
  diasNoTrabajados = [0, 6], // 0: Domingo, 6: Sábado
  excepcionesHorarias = [] // ['yyyy-MM-dd'] fechas específicas cerradas
}) {
  const [mesActual, setMesActual] = useState(new Date());
  const [fechasVisibles, setFechasVisibles] = useState([]);
  const [diasDisponibles, setDiasDisponibles] = useState([]);
  const [cargando, setCargando] = useState(false);

  // Construir grid de fechas del mes
  useEffect(() => {
    const inicio = startOfWeek(startOfMonth(mesActual), { weekStartsOn: 1 });
    const fin = endOfWeek(endOfMonth(mesActual), { weekStartsOn: 1 });
    const dias = [];
    let dia = inicio;
    while (dia <= fin) {
      dias.push(dia);
      dia = addDays(dia, 1);
    }
    setFechasVisibles(dias);
  }, [mesActual]);

  // Obtener días disponibles del backend para el mes actual
  useEffect(() => {
    if (!servicioId) {
      setDiasDisponibles([]);
      return;
    }
    const anioMes = format(mesActual, 'yyyy-MM');
    setCargando(true);
    api.get(`/disponibilidad/mes/${anioMes}/${servicioId}`)
      .then(res => setDiasDisponibles(res.data.diasDisponibles || []))
      .catch(err => {
        console.error('❌ Error al cargar días disponibles:', err);
        setDiasDisponibles([]);
      })
      .finally(() => setCargando(false));
  }, [mesActual, servicioId]);

  const hoy = startOfDay(new Date());
  const limite = addDays(hoy, diasMaximos);

  const getEstadoDia = (fecha) => {
    const fechaStr = format(fecha, 'yyyy-MM-dd');
    if (!isSameMonth(fecha, mesActual)) return 'fueraMes';
    if (isBefore(fecha, hoy)) return 'inactivo';
    if (isAfter(fecha, limite)) return 'fueraRango';
      // Si es excepción de apertura, la saltamos y dejamos que diasDisponibles decida
  if (!excepcionesHorarias.includes(fechaStr)) {
    // Días no laborables fijos (sábados/domingos)
    if (diasNoTrabajados.includes(fecha.getDay())) return 'cerrado';
    // Aquí podrías añadir excepciones de cierre (si tuvieras fechas cerradas)
  }
    if (!servicioId || cargando) return 'cargando';
    if (diasDisponibles.includes(fechaStr)) return 'disponible';
    return 'completo';
  };

  return (
    <div className='grid-calendario'>
      <div className='calendario-header'>
        <button onClick={() => setMesActual(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1))}>
          <img src='/images/izquierda.svg' alt='Anterior' />
        </button>
        <span className='calendario-mes'>{format(mesActual, 'MMMM yyyy', { locale: es })}</span>
        <button onClick={() => setMesActual(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1))}>
          <img src='/images/derecha.svg' alt='Siguiente' />
        </button>
      </div>

      <div className='dias-de-la-semana' style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px' }}>
        {['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'].map(dia => (
          <div key={dia}><strong>{dia}</strong></div>
        ))}

        {fechasVisibles.map((fecha, i) => {
          const estado = getEstadoDia(fecha);
          const seleccionable = estado === 'disponible';
          const seleccionado = isSameDay(fecha, new Date(fechaSeleccionada));
          const fechaStr = format(fecha, 'yyyy-MM-dd');

          // Título vacío para 'cerrado'
          let titulo = '';
          if (estado === 'fueraRango') {
            titulo = `Solo puedes reservar hasta ${diasMaximos} días desde hoy`;
          } else if (estado === 'completo') {
            titulo = 'Sin huecos disponibles';
          }

          return (
            <button
              key={i}
              className={
                `calendario-boton` +
                (estado === 'cerrado' ? ' calendario-boton-disabled' : '') +
                (estado === 'completo' ? ' calendario-boton-completo' : '') +
                (estado === 'fueraRango' ? ' calendario-boton-fueraRango' : '')
              }
              disabled={estado !== 'disponible'}
              style={{
                backgroundColor: seleccionado ? '#25d366' : 'white',
                color: seleccionado ? 'white' : 'black',
                opacity: ['inactivo', 'cerrado', 'fueraMes', 'fueraRango'].includes(estado) ? 0.3 : 1,
                cursor: seleccionable ? 'pointer' : 'not-allowed',
              }}
              onClick={() => seleccionable && onSeleccionarFecha(fechaStr)}
              title={titulo}
            >
              {format(fecha, 'd')}
              {(() => {
            const dia = fecha.getDate();
            const mes = fecha.getMonth(); // Julio = 6
            const anio = fecha.getFullYear();

            if (mes === 11 && anio === 2025) {
              if (dia === 24) {
                return <img src="/images/arbol-de-navidad.png" alt="Navidad" className="img-calendario-evento" />;
              }
              if (dia === 31) {
                return <img src="/images/salud.png" alt="Año nuevo" className="img-calendario-evento" />;
              }
              /*if (dia >= 11 && dia <= 20) {
                return <img src="/images/abanico.png" alt="Feria La Línea" className="img-calendario-evento-feria" />;
              }*/
            }
            if (mes === 0 && anio === 2026) {
              if (dia === 6) {
                return <img src="/images/los-tres-reyes-magos.svg" alt="Reyes Magos" className="img-calendario-evento" />;
              }
            }

            if (mes === 6 && anio === 2026) {
              if (dia === 17) {
                return <img src="/images/corona.svg" alt="Feria La Línea" className="img-calendario-evento-feria-normal" />;
              }
              if (dia === 22) {
                return <img src="/images/mujer.svg" alt="Feria La Línea" className="img-calendario-evento-feria-normal" />;
              }
              if ((dia >= 18 && dia <= 21) || (dia >= 23 && dia <= 25)) {
                return <img src="/images/abanico.png" alt="Feria La Línea" className="img-calendario-evento-feria" />;
              }
              if (dia === 26) {
                return <img src="/images/fuegos-artificiales.svg" alt="Feria La Línea" className="img-calendario-evento-feria-normal" />;
              }
            }

            return null;
          })()}


              {estado === 'completo' && <span>Sin huecos</span>}

            </button>
          );
        })}
      </div>
    </div>
  );
}
